// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {Media} from "@models";

@Component({
	selector: "sim-presentation-viewer",
	templateUrl: "./presentation-viewer.component.html",
	styleUrls: ["./presentation-viewer.component.scss"],
	standalone: false,
})
export class PresentationViewerComponent implements OnInit {
	@Input() file: string | File;
	@Input() media: Media = null;
	@Input() pageNum: number;
	@Input() enableAutoPlay: boolean;
	@Input() autoPlayInterval: number;
	@Input() width = 1920;
	@Input() height = 1080;
	@Input() autoSize = false;

	numberOfPages = output<number>();
	loadingError = output<boolean>();
	loaded = output<boolean>();

	constructor() {}

	ngOnInit() {}

	public getType(): "PPTX" | "ODP" {
		let mediaName = (this.media?.fileName ?? (<File>this.file)?.name ?? <string>this.file)?.toLowerCase();
		return mediaName?.endsWith(".pptx") ? "PPTX" : "ODP";
	}
}
